export enum CHALLENGE_OR_TEAM_VALUES {
  CREATED = 'Created',
  JOINED = 'Joined',
}

export const PRIMARY_AVATAR_SIZE = 40;
export const SECONDARY_AVATAR_SIZE = 20;
